var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmailDeliveryTable',{attrs:{"fetchAction":"EmailDeliveryStore/getHistoryList","clearHistoryAction":"EmailDeliveryStore/clearHistory","placeholder":"No email history available.","autoRefresh":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }